export const CHECKOUT_LABELS = 'checkout';

const FreeShippingProgressBarLabels = {
  checkout: {
    bagPage: {
      lbl_freeShipping_cartTile: 'Free Shipping',
    },
  },
};

export default FreeShippingProgressBarLabels;
